import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import POLines from './pages/POLines';
import Tasks from './pages/Tasks';
import Chat from './pages/Chat';
import DataExchange from './pages/DataExchange';
import Settings from './pages/Settings';
import Users from './pages/Users';
import Admin from './pages/Admin';
import ResponseCheck from './pages/ResponseCheck';

// Protected route wrapper
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="loading">
        <div className="spinner" />
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      
      <Route path="/" element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route index element={<Dashboard />} />
        <Route path="po-lines" element={<POLines />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="chat" element={<Chat />} />
        <Route path="response-check" element={<ResponseCheck />} />
        <Route path="data-exchange" element={<DataExchange />} />
        {/* Redirect old upload path */}
        <Route path="upload" element={<Navigate to="/data-exchange" replace />} />
        <Route path="users" element={<Users />} />
        <Route path="admin" element={<Admin />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;